import { View, Text, ScrollView, TouchableOpacity, useWindowDimensions, Platform, Image } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { useRouter } from "expo-router";
import { Ionicons } from "@expo/vector-icons";
import Head from "expo-router/head";
import { PartnersGrid } from "../../components/PartnersGrid";

const NAVY = "#1B2A4A";
const NAVY_DARK = "#111C30";
const ORANGE = "#F5A623";
const WHITE = "#FFFFFF";

export default function PartnersScreen() {
  const router = useRouter();
  const { width } = useWindowDimensions();
  const isWide = width >= 768;
  const year = new Date().getFullYear();

  const DashLogo = ({ height }: { height: number }) =>
    Platform.OS === "web" ? (
      <img src="/logo-full.png" alt="Dash-Hound" style={{ height, objectFit: "contain" } as any} />
    ) : (
      <Image source={require("../../assets/logo.png")} style={{ height, width: height * 2.3 }} resizeMode="contain" />
    );

  const NavLink = ({ label, to }: { label: string; to: string }) => (
    <TouchableOpacity onPress={() => router.push(to as any)} style={{ marginBottom: 12 }}>
      <Text style={{ color: "rgba(255,255,255,0.6)", fontSize: 14, fontWeight: "500", textAlign: isWide ? "left" : "center" }}>{label}</Text>
    </TouchableOpacity>
  );

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: NAVY }} edges={["top"]}>
      {Platform.OS === "web" && (
        <Head>
          <title>Partners — Dash-Hound</title>
          <meta name="description" content="The clubs and businesses partnering with Dash-Hound and the Fast CAT community." />
        </Head>
      )}
      <View style={{ flex: 1, backgroundColor: "#FFFFFF" }}>
        {/* Top nav bar */}
        <View style={{ backgroundColor: NAVY, height: 44, justifyContent: "center", paddingHorizontal: 12 }}>
          <TouchableOpacity
            onPress={() => (router.canGoBack() ? router.back() : router.replace("/" as any))}
            style={{ position: "absolute", left: 8, top: 0, bottom: 0, justifyContent: "center", paddingHorizontal: 8 }}
            hitSlop={{ top: 12, bottom: 12, left: 12, right: 12 }}
          >
            <Ionicons name="chevron-back" size={26} color="#FFFFFF" />
          </TouchableOpacity>
        </View>

        <ScrollView contentContainerStyle={{ paddingBottom: 0 }}>
          {/* Hero — logo top center + Our Partners */}
          <View style={{ backgroundColor: NAVY, paddingHorizontal: 24, paddingTop: 12, paddingBottom: isWide ? 44 : 34, alignItems: "center" }}>
            <DashLogo height={isWide ? 132 : 100} />
            <Text style={{ fontSize: isWide ? 34 : 26, fontWeight: "800", color: WHITE, textAlign: "center", marginTop: 10, letterSpacing: -0.5 }}>
              Our Partners
            </Text>
            <Text style={{ fontSize: 15, color: "rgba(255,255,255,0.72)", textAlign: "center", marginTop: 10, maxWidth: 620, alignSelf: "center", lineHeight: 22 }}>
              The clubs and businesses that support the Fast CAT community and Dash-Hound. Tap any logo to visit their site.
            </Text>
          </View>

          {/* Partners grid — white */}
          <View style={{ backgroundColor: "#FFFFFF", paddingVertical: isWide ? 48 : 36, paddingHorizontal: 24 }}>
            <PartnersGrid isWide={isWide} columns={isWide ? 3 : 2} />
          </View>

          {/* CTA — orange */}
          <View style={{ backgroundColor: ORANGE, paddingVertical: isWide ? 80 : 56, paddingHorizontal: 24, alignItems: "center" }}>
            <Text style={{ fontSize: isWide ? 40 : 28, fontWeight: "900", color: NAVY, textAlign: "center", letterSpacing: -0.8, lineHeight: isWide ? 50 : 36, marginBottom: 16 }}>
              Ready to Track Your{"\n"}Fast CAT Journey?
            </Text>
            <Text style={{ color: "rgba(27,42,74,0.7)", fontSize: 16, textAlign: "center", lineHeight: 26, marginBottom: 32, maxWidth: 440 }}>
              Create your free account and start tracking today.
            </Text>
            <TouchableOpacity
              style={{ backgroundColor: NAVY, paddingVertical: 16, paddingHorizontal: 40, borderRadius: 30 }}
              onPress={() => router.push("/(auth)/register/" as any)}
              activeOpacity={0.85}
            >
              <Text style={{ color: WHITE, fontSize: 18, fontWeight: "700" }}>Get Started Free</Text>
            </TouchableOpacity>
          </View>

          {/* Footer — navy: logo + navigation */}
          <View style={{ backgroundColor: NAVY_DARK, paddingVertical: 48, paddingHorizontal: 24, borderTopWidth: 1, borderTopColor: "rgba(255,255,255,0.08)" }}>
            <View style={{
              flexDirection: isWide ? "row" : "column",
              justifyContent: "center",
              alignItems: "center",
              maxWidth: 1000,
              width: "100%",
              alignSelf: "center",
              gap: isWide ? 80 : 28,
            }}>
              <DashLogo height={110} />
              <View style={{ alignItems: isWide ? "flex-start" : "center" }}>
                <Text style={{ fontSize: 14, fontWeight: "700", color: ORANGE, marginBottom: 14, textTransform: "uppercase", letterSpacing: 1, textAlign: isWide ? "left" : "center" }}>Navigation</Text>
                <NavLink label="Home" to="/" />
                <NavLink label="Partners" to="/(auth)/partners/" />
                <NavLink label="Support" to="/(auth)/support/" />
                <NavLink label="Privacy Policy" to="/(auth)/privacy/" />
                <NavLink label="Terms of Service" to="/(auth)/terms/" />
              </View>
            </View>
            <Text style={{ color: "rgba(255,255,255,0.4)", fontSize: 12, textAlign: "center", marginTop: 32 }}>
              © {year} Dash-Hound. All rights reserved.
            </Text>
          </View>
        </ScrollView>
      </View>
    </SafeAreaView>
  );
}
